<template>
  <div>
    <span v-if="isActive" class="badge-info p-1 px-2">{{ $t('planning.state_labels.activated') }}</span>
    <span v-else class="badge-secondary p-1 px-2">{{ $t('planning.state_labels.deactivated') }}</span>
  </div>
</template>

<script>
export default {
  name: "ActiveRenderer",
  props: ["object", "columnKey"],
  computed: {
    isActive: function() {
      return !!this.object[this.columnKey]  
    }  
  }
};
</script>
  